/**
 * 7×24 heatmap for query distribution. Rows = weekday (Mon..Sun), cols = hour.
 * Colour intensity scales linearly to the grid max. Empty cells stay at low opacity.
 * `insights` renders auto-detected callouts (weekend/after-hours/peak) as pill badges.
 */
const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function Heatmap({
  grid = [], baseColor = "56, 189, 248", // sky-400 RGB
  insights = null,
  testId = "heatmap",
}) {
  const max = Math.max(1, ...grid.flat());
  return (
    <div className="w-full overflow-x-auto" data-testid={testId}>
      {insights && insights.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3" data-testid={`${testId}-insights`}>
          {insights.map((c) => (
            <span
              key={c.id}
              data-testid={`${testId}-insight-${c.id}`}
              className={`text-[11px] px-2.5 py-1 rounded-full border ${
                c.tone === "warn"
                  ? "border-amber-500/40 bg-amber-500/10 text-amber-500"
                  : "border-sky-500/40 bg-sky-500/10 text-sky-500"
              }`}
            >
              {c.label}
            </span>
          ))}
        </div>
      )}
      <div className="min-w-[560px]">
        <div className="grid grid-cols-[36px_repeat(24,1fr)] gap-[2px] text-[9px] text-muted-foreground font-mono">
          <div />
          {Array.from({ length: 24 }).map((_, h) => (
            <div key={h} className="text-center" data-testid={`${testId}-hour-${h}`}>
              {h % 3 === 0 ? String(h).padStart(2, "0") : ""}
            </div>
          ))}
          {DAYS.map((day, r) => (
            <div key={`row-${r}`} className="contents">
              <div className="pr-1 text-right leading-[16px]">{day}</div>
              {Array.from({ length: 24 }).map((_, h) => {
                const val = (grid[r] || [])[h] || 0;
                const opacity = val === 0 ? 0.06 : 0.15 + (val / max) * 0.85;
                return (
                  <div
                    key={`c-${r}-${h}`}
                    data-testid={`${testId}-cell-${r}-${h}`}
                    title={`${day} ${String(h).padStart(2, "0")}:00 — ${val} quer${val === 1 ? "y" : "ies"}`}
                    className="h-4 rounded-[2px]"
                    style={{ background: `rgba(${baseColor}, ${opacity})` }}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
